import * as React from 'react';
import { snap, visualize } from 'storybook-snapper';
import { OverlappingCard, Text, TextTypography, Divider, Button } from '..';
import { classes } from './OverlappingCard.visual.st.css';

const imageComponent = (width = 550, height = 322) => (
  <div
    style={{
      height: '100%',
      backgroundImage: `url(https://static.wixstatic.com/media/f77a29_e163ea53eab341b48c4edd7049f290f1~mv2.jpg/v1/fill/w_${width},h_${height},al_c,lg_1,q_80,enc_auto/f77a29_e163ea53eab341b48c4edd7049f290f1~mv2.jpg)`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      backgroundSize: 'cover',
    }}
  />
);

const OverlappingCardVisual = (props) => {
  return (
    <OverlappingCard
      media={imageComponent()}
      className={props.className}
      info={
        <div>
          <div style={{ marginBottom: '10px' }}>
            <Text typography={TextTypography.smallTitle}>Overlapping</Text>
          </div>
          <div style={{ marginBottom: '10px' }}>
            <Text typography={TextTypography.runningText}>Tagline</Text>
          </div>
          <div style={{ margin: '10px 0' }}>
            <Divider />
          </div>
          <div style={{ marginTop: '20px' }}>
            <Button>Book</Button>
          </div>
        </div>
      }
    />
  );
};

visualize('OverlappingCard', () => {
  snap('default layout', <OverlappingCardVisual />);
  snap('styles overrides', <OverlappingCardVisual className={classes.root} />);
});
